var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisconnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 0.125854C6.21292 0.125854 2.8024 1.82758 0.350586 4.54271L1.6494 5.71556C3.80419 3.32936 6.75763 1.87585 9.99999 1.87585C13.2424 1.87585 16.1958 3.32936 18.3506 5.71556L19.6494 4.54271C17.1976 1.82758 13.7871 0.125854 9.99999 0.125854Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 4.25378C7.24752 4.25378 4.77023 5.47093 2.99139 7.4088L4.2806 8.59221C5.75913 6.98149 7.78184 6.00378 9.99996 6.00378C12.2181 6.00378 14.2408 6.98149 15.7193 8.59221L17.0085 7.4088C15.2297 5.47093 12.7524 4.25378 9.99996 4.25378Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2375 14.0004L13.4683 16.2312L12.2309 17.4686L10.0001 15.2378L7.7692 17.4687L6.53176 16.2313L8.76266 14.0004L6.53168 11.7694L7.76911 10.532L10.0001 12.763L12.231 10.5321L13.4684 11.7695L11.2375 14.0004Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnect);
export default __webpack_public_path__ + "static/media/disconnect.e26c3973871ab7499d19c4f0ee940946.svg";
export { ForwardRef as ReactComponent };